import { FormikProps } from 'formik';
import React from 'react';
import { phoneMask } from '../../../../../_metronic/_helpers/MasksHelper';
import { maskDocument } from '../../../../pages/Clientes/documentUtils';
import { useFieldError } from '../hooks/useFieldError';
import { Card, FormRow, SectionTitle } from '../styles';
import { IPaymentLinkFormValues } from '../types/types';

interface IdentificationSectionProps {
  form: FormikProps<IPaymentLinkFormValues>;
}

export const IdentificationSection: React.FC<IdentificationSectionProps> = ({
  form,
}) => {
  const hasError = useFieldError(form);

  const showNameError = hasError('name');
  const showPhoneError = hasError('phone');
  const showEmailError = hasError('email');
  const showDocumentError = hasError('document');

  return (
    <Card>
      <SectionTitle>Identificação</SectionTitle>

      {form.values.requiresCustomerData && (
        <FormRow className="two-columns">
          <div className="form-group">
            <label htmlFor="payment-name">
              Nome completo <span className="text-danger">*</span>
            </label>

            <input
              id="payment-name"
              name="name"
              type="text"
              autoComplete="name"
              className={showNameError ? 'is-invalid' : undefined}
              aria-required="true"
              aria-invalid={showNameError}
              aria-describedby={showNameError ? 'payment-name-error' : undefined}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.values.name}
            />

            {showNameError && (
              <span
                id="payment-name-error"
                className="invalid-feedback"
                role="alert"
              >
                {form.errors.name}
              </span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="payment-phone">Telefone</label>

            <input
              id="payment-phone"
              name="phone"
              type="tel"
              autoComplete="tel"
              placeholder="(00) 00000-0000"
              className={showPhoneError ? 'is-invalid' : undefined}
              aria-invalid={showPhoneError}
              aria-describedby={
                showPhoneError ? 'payment-phone-error' : undefined
              }
              onChange={(e) =>
                form.setFieldValue('phone', phoneMask(e.target.value))
              }
              onBlur={form.handleBlur}
              value={form.values.phone}
            />

            {showPhoneError && (
              <span
                id="payment-phone-error"
                className="invalid-feedback"
                role="alert"
              >
                {form.errors.phone}
              </span>
            )}
          </div>
        </FormRow>
      )}

      <FormRow className="two-columns">
        <div className="form-group">
          <label htmlFor="payment-email">
            E-mail <span className="text-danger">*</span>
          </label>

          <input
            id="payment-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="nome@escritorio.com.br"
            className={showEmailError ? 'is-invalid' : undefined}
            aria-required={form.values.requiresCustomerData}
            aria-invalid={showEmailError}
            aria-describedby={
              showEmailError ? 'payment-email-error' : undefined
            }
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            value={form.values.email}
          />

          {showEmailError && (
            <span
              id="payment-email-error"
              className="invalid-feedback"
              role="alert"
            >
              {form.errors.email}
            </span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="payment-document">
            CPF/CNPJ <span className="text-danger">*</span>
          </label>

          <input
            id="payment-document"
            name="document"
            type="text"
            inputMode="numeric"
            placeholder="000.000.000-00"
            className={showDocumentError ? 'is-invalid' : undefined}
            aria-required={form.values.requiresCustomerData}
            aria-invalid={showDocumentError}
            aria-describedby={
              showDocumentError ? 'payment-document-error' : undefined
            }
            onChange={(e) =>
              form.setFieldValue('document', maskDocument(e.target.value))
            }
            onBlur={form.handleBlur}
            value={form.values.document}
          />

          {showDocumentError && (
            <span
              id="payment-document-error"
              className="invalid-feedback"
              role="alert"
            >
              {form.errors.document}
            </span>
          )}
        </div>
      </FormRow>
    </Card>
  );
};
